import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SearchPageRoutingModule } from './search-routing.module';

import { SearchPage } from './search.page';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { SearchBreadcrumbComponent } from './components/search-breadcrumb/search-breadcrumb.component';
import { SearchResultComponent } from './components/search-result/search-result.component';
import { SearchSharedModule } from './shared/search-shared.module';
import { ProductReplacementPopoverComponent } from './components/product-replacement-popover/product-replacement-popover.component';
import { SearchFiltersDesktopComponent } from './components/search-filters/search-filters-desktop/search-filters-desktop.component';
import { SearchFiltersMobileComponent } from './components/search-filters/search-filters-mobile/search-filters-mobile.component';
import { SearchFiltersTabletComponent } from './components/search-filters/search-filters-tablet/search-filters-tablet.component';
import { SearchFiltersBaseComponent } from './components/search-filters/search-filters-base.component';
import { RefinementMenuComponent } from './components/search-filters/search-filtering/refinement-menu/refinement-menu.component';
// eslint-disable-next-line max-len
import { StaticRefinementMenuComponent } from './components/search-filters/search-filtering/static-refinement-menu/static-refinement-menu.component';
// eslint-disable-next-line max-len
import { RangeRefinementMenuComponent } from './components/search-filters/search-filtering/range-refinement-menu/range-refinement-menu.component';
import { SelectedFiltersComponent } from './components/search-filters/search-filtering/selected-filters/selected-filters.component';
import { SearchFilteringComponent } from './components/search-filters/search-filtering/search-filtering.component';
import { ProductExceptionPopoverComponent } from './components/product-exception-popover/product-exception-popover.component';
import { ProductCardPopoverComponent } from './components/product-card-popover/product-card-popover.component';
import { SearchBannerComponent } from './components/search-banner/search-banner.component';
import { HeaderModule } from '@shared/components/header/header.module';
export const httpLoaderFactory = (http: HttpClient) =>
  new TranslateHttpLoader(http, 'assets/i18n/', '.json');

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HeaderModule,
    SharedModule,
    SearchSharedModule,
    SearchPageRoutingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [
    SearchPage,
    SearchBreadcrumbComponent,
    SearchResultComponent,
    SearchFilteringComponent,
    SearchFiltersDesktopComponent,
    SearchFiltersMobileComponent,
    SearchFiltersTabletComponent,
    SearchFiltersBaseComponent,
    ProductCardPopoverComponent,
    ProductReplacementPopoverComponent,
    ProductExceptionPopoverComponent,
    RefinementMenuComponent,
    StaticRefinementMenuComponent,
    RangeRefinementMenuComponent,
    SelectedFiltersComponent,
    SearchBannerComponent,
  ],
})
export class SearchPageModule {}
